import RoutesConfig from "./RoutesConfig";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { useEffect, useState } from "react";
import useApplicationData from "./hooks/useApplicationData";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

function App() {
  const { fetchApplicationData, fetchTotalApplicationsCount } =
    useApplicationData();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // State for loader

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");

    if (accessToken && refreshToken) {
      setIsLoading(true); // Show loader when API call starts

      fetchApplicationData(accessToken, refreshToken)
        .then(() => {
          fetchTotalApplicationsCount(accessToken, refreshToken); // Call another function after API call completes
        })
        .finally(() => {
          setIsLoading(false); // Hide loader after API call completes
        });
    } else {
      navigate("/");
    }
  }, []);

  return (
    <div>
      {/* Loader Overlay */}
      {isLoading && location.pathname !== "/" && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.4)", // Transparent grey background
            zIndex: 9999, // Ensures it overlays everything
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress
            size={60}
            sx={{
              color: "#ea580c",
            }}
          />
        </Box>
      )}

      {/* Main Content */}
      <div className="min-h-screen overflow-hidden">
        <Header />
        <div className="mx-auto mb-8 relative container">
          <RoutesConfig />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
